import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import photo from "../images/Login.jpg";
import { Icon } from "react-icons-kit";
import { eye } from "react-icons-kit/fa/eye";
import { eyeSlash } from "react-icons-kit/fa/eyeSlash";
import { FaGoogle, FaMobileAlt } from "react-icons/fa";
import { signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword, getAuth, updatePassword } from "firebase/auth";
import { authentication } from "../Firebase";
import { loadMobileType, register } from "../store/reducers/userReducer";
import PhoneLoginTwo from "./PhoneLoginTwo";
import RagisterModalTwo from "./RegisterModalTwo";
import ForgotPasswordTwo from "./ForgotPasswordTwo";
import { translate } from "../utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { passwordProblem } from "../utils/passwordRules";

// PT-PASSWORD-FIX v4
// Login = email + password. Old members (password was "91" + mobile) can still log in once
// with their mobile number, and are then asked to set a new password.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;


// new passwords must contain letters, so an all-digit password is always an old mobile-number password
const isLegacyMobilePassword = (pw) => /^\d+$/.test(pw);
// old site: password = mobile, with "91" added in front unless it already started with 91
const legacyPasswordFor = (typed) => (typed.startsWith("91") ? typed : "91" + typed);

const BAD_LOGIN_CODES = ["auth/wrong-password", "auth/invalid-credential", "auth/invalid-login-credentials", "auth/user-not-found"];

const loginErrorMessage = (code) => {
    switch (code) {
        case "auth/invalid-email":
            return "Invalid email. Please enter a valid email.";
        case "auth/user-disabled":
            return "This account has been disabled. Please contact support.";
        case "auth/too-many-requests":
            return "Too many attempts. Please wait a few minutes or use Forgot Password.";
        case "auth/network-request-failed":
            return "Network error. Please check your internet and try again.";
        default:
            if (BAD_LOGIN_CODES.includes(code)) return "Email or password is incorrect.";
            return "Login failed. Please try again.";
    }
};

function SignInModal(props) {
    const [modalShow, setModalShow] = useState(false);
    const [ForgotModalShow, setForgotModalShow] = useState(false);
    const [PhoneModalShow, setPhoneModalShow] = useState(false);
    const initialValues = { email: "", password: "" };
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});
    const [showPw, setShowPw] = useState(false);
    const [busy, setBusy] = useState(false);

    // set-new-password step for old members
    const [needNewPw, setNeedNewPw] = useState(false);
    const [newPw, setNewPw] = useState({ password: "", confirm: "" });
    const [newPwError, setNewPwError] = useState("");
    const [newPwBusy, setNewPwBusy] = useState(false);
    const [showNewPw, setShowNewPw] = useState(false);

    const navigate = useNavigate();
    const auth = getAuth();
    // eslint-disable-next-line
    const [phonenum, setPhonenum] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const validate = (values) => {
        const errors = {};
        if (!values.email) {
            errors.email = "Email is required!";
        } else if (!EMAIL_RE.test(values.email.trim())) {
            errors.email = "Enter Valid email";
        }
        if (!values.password) {
            errors.password = "Password is required!";
        }
        return errors;
    };

    // sign in google
    const signInWithGoogle = () => {
        const provider = new GoogleAuthProvider();
        signInWithPopup(authentication, provider)
            .then(async (response) => {
                props.onHide();
                props.setIsLogout(true);
                register(
                    response.user.uid,
                    response.user.displayName,
                    response.user.email,
                    "",
                    "gmail",
                    response.user.photoURL,
                    "1",
                    "",
                    (success) => {
                        if (success.data.is_login === "1") {
                            navigate("/profile-update");
                        }
                        props.setisloginloading(false);
                    },
                    (error) => {
                        toast.error(translate("deactiveMsg"));
                    }
                );
            })
            .catch((err) => {
                console.log(err.message);
            });
    };

    const finishLogin = (user, email, mustChangePassword) => {
        // email verification no longer blocks login; EmailVerifyBanner reminds the member instead
        props.setIsLogout(true);
        props.onHide();
        setFormValues(initialValues);

        register(
            user.uid,
            "",
            email,
            "",
            "email",
            "",
            "1",
            "",
            (success) => {
                if (success.data.is_login === "1" && !mustChangePassword) {
                    navigate("/profile-update");
                }
                loadMobileType(false);
                props.setisloginloading(false);
            },
            (error) => {
                toast.error(translate("deactiveMsg"));
            }
        );

        if (mustChangePassword) {
            setNewPw({ password: "", confirm: "" });
            setNewPwError("");
            setNeedNewPw(true);
        }
    };

    const Signin = async () => {
        const email = formValues.email.trim();
        const typed = formValues.password;
        try {
            const cred = await signInWithEmailAndPassword(auth, email, typed);
            finishLogin(cred.user, email, isLegacyMobilePassword(typed));
        } catch (error) {
            // old members: password is "91" + 10-digit mobile
            if (BAD_LOGIN_CODES.includes(error.code) && /^\d{6,12}$/.test(typed) && legacyPasswordFor(typed) !== typed) {
                try {
                    const cred = await signInWithEmailAndPassword(auth, email, legacyPasswordFor(typed));
                    finishLogin(cred.user, email, true);
                    return;
                } catch (error2) {
                    toast.error(loginErrorMessage(error2.code));
                    return;
                }
            }
            toast.error(loginErrorMessage(error.code));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (busy) return;
        const errors = validate(formValues);
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) return;
        setBusy(true);
        try {
            await Signin();
        } finally {
            setBusy(false);
        }
    };

    const saveNewPassword = async (e) => {
        e.preventDefault();
        if (newPwBusy) return;
        const problem = passwordProblem(newPw.password);
        if (problem) return setNewPwError(problem);
        if (newPw.password !== newPw.confirm) return setNewPwError("Passwords do not match");
        if (!auth.currentUser) return setNewPwError("Session expired. Please log in again.");
        setNewPwBusy(true);
        try {
            await updatePassword(auth.currentUser, newPw.password);
            setNeedNewPw(false);
            setNewPw({ password: "", confirm: "" });
            toast.success("New password saved. Use it from next login.");
        } catch (error) {
            if (error.code === "auth/requires-recent-login") {
                setNewPwError("Please log out, log in again and then set the password.");
            } else if (error.code === "auth/weak-password") {
                setNewPwError("Password is too weak.");
            } else {
                setNewPwError("Could not save password. Please try again.");
            }
        } finally {
            setNewPwBusy(false);
        }
    };

    return (
        <>
            <div>
                <Modal {...props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered dialogClassName="border-radius-2">
                    <div className="ModalWrapper" id="ModalWrapper">
                        <div style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "20px" }} id="login_img1">
                            <img className="ModalImg" src={photo} alt="" />
                            <div className="logo-img-overlay"></div>
                            <div className="logo-text">
                                <h4>{translate("beautifulltheme")}</h4>
                                <p> {translate("bestinvestment")}</p>
                            </div>
                        </div>
                        <div id="modal-content">
                            <Modal.Header closeButton>
                                <Modal.Title id="contained-modal-title-vcenter">{translate("loginTxt")}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="">
                                    <div>
                                        <div className="welcom-back">
                                            <h5>
                                                <strong>{translate("welcomeback")}</strong>
                                            </h5>
                                            <div id="Welcom" style={{ fontSize: "14px" }}>
                                                {" "}
                                                {translate("enter-email-password")}
                                            </div>
                                        </div>
                                        <form className="my-2" onSubmit={handleSubmit} noValidate>
                                            <div className="form-floating mb-3">
                                                <input type="email" autoComplete="username" className="form-control" name="email" id="floatingInput" placeholder="name@example.com" aria-describedby="emailHelp" value={formValues.email} onChange={handleChange} />
                                                <p className="error-msg"> {formErrors.email}</p>
                                                <label htmlFor="floatingInput">{translate("emailaddress")}</label>
                                            </div>
                                            <div className="form-floating mb-3">
                                                <input type={showPw ? "text" : "password"} autoComplete="current-password" className="form-control" id="floatingPassword" placeholder="Password" name="password" value={formValues.password} onChange={handleChange} />
                                                <label htmlFor="floatingPassword">{translate("passLbl")}</label>
                                                <span onClick={() => setShowPw(!showPw)} className="password-icon" style={{ cursor: "pointer" }}>
                                                    <Icon icon={showPw ? eye : eyeSlash} size={20} />
                                                </span>
                                                <p className="error-msg"> {formErrors.password}</p>
                                                <small className="text-muted d-block mb-1" style={{ fontSize: "12px" }}>
                                                    Old members: if you have not set a password yet, enter your 10-digit mobile number once.
                                                </small>
                                                <p
                                                    onClick={() => {
                                                        props.onHide();
                                                        setModalShow(false);
                                                        setPhoneModalShow(false);
                                                        setForgotModalShow(true);
                                                    }}
                                                    id="forgot"
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {translate("forgotPassLbl")}
                                                </p>
                                            </div>
                                            <div className="py-3" id="login">
                                                <button type="submit" className="btn   btn-lg  w-100" id="loginbutton" disabled={busy}>
                                                    {busy ? "Please wait..." : translate("loginTxt")}
                                                </button>
                                            </div>
                                        </form>
                                        <div className="bordert mx-3 my-3 py-2"></div>
                                    </div>
                                    <div className="container px-0" id="social_buttons">
                                        <div className="row">
                                            <div className="col-lg-6 col-12">
                                                <button id="login-social2" type="button" className=" btn " onClick={signInWithGoogle}>
                                                    <FaGoogle /><p>{translate("signin-with-google")}</p>
                                                </button>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <Button
                                                    id="login-social3"
                                                    type="button"
                                                    onClick={() => {
                                                        props.onHide();
                                                        setModalShow(false);
                                                        setPhoneModalShow(true);
                                                        setForgotModalShow(false);
                                                    }}
                                                >
                                                    <FaMobileAlt /><p>{translate("signin-with-phone")}</p>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>

                            <div className="footer">
                                <h6 className="">
                                    {translate("First Time User has to register yourself to become A member of AntarRashtriya Hindu Parishad")}
                                    <p className="mt-1"
                                        style={{ cursor: "pointer", fontSize: "18px", fontWeight: "bold", color: "#3B5998" }}
                                        onClick={() => {
                                            props.onHide();
                                            setPhoneModalShow(false);
                                            setForgotModalShow(false);
                                            setModalShow(true);
                                        }}
                                    >
                                        {" "}
                                        {translate("register")} {" "}
                                    </p>
                                </h6>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>

            {/* Old members must set a new password once */}
            <Modal show={needNewPw} backdrop="static" keyboard={false} centered>
                <div style={{ background: "#fff", borderRadius: "12px", overflow: "hidden" }}>
                <Modal.Header>
                    <Modal.Title>Set a new password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={{ fontSize: "14px" }}>
                        For your account's safety, your mobile number can no longer be used as the password. Please set a new password now.
                    </p>
                    <form onSubmit={saveNewPassword} noValidate>
                        <div className="form-floating mb-3">
                            <input type={showNewPw ? "text" : "password"} autoComplete="new-password" className="form-control" id="ptNewPassword" placeholder="New password" value={newPw.password} onChange={(e) => setNewPw({ ...newPw, password: e.target.value })} />
                            <label htmlFor="ptNewPassword">New password</label>
                            <span onClick={() => setShowNewPw(!showNewPw)} className="password-icon" style={{ cursor: "pointer" }}>
                                <Icon icon={showNewPw ? eye : eyeSlash} size={20} />
                            </span>
                        </div>
                        <div className="form-floating mb-2">
                            <input type={showNewPw ? "text" : "password"} autoComplete="new-password" className="form-control" id="ptNewPassword2" placeholder="Confirm password" value={newPw.confirm} onChange={(e) => setNewPw({ ...newPw, confirm: e.target.value })} />
                            <label htmlFor="ptNewPassword2">Confirm password</label>
                        </div>
                        <small className="text-muted d-block mb-2">At least 8 characters, with letters and numbers.</small>
                        <p className="error-msg">{newPwError}</p>
                        <button type="submit" className="btn btn-lg w-100" id="loginbutton" disabled={newPwBusy}>
                            {newPwBusy ? "Saving..." : "Save password"}
                        </button>
                    </form>
                </Modal.Body>
                </div>
            </Modal>

            <ForgotPasswordTwo setLoginModalShow={props.setLoginModalShow} show={ForgotModalShow} onHide={() => setForgotModalShow(false)} />
            <RagisterModalTwo setIsLogout={props.setIsLogout} setLoginModalShow={props.setLoginModalShow} show={modalShow} onHide={() => setModalShow(false)} />
            <PhoneLoginTwo setisloginloading={props.setisloginloading} setIsLogout={props.setIsLogout} setLoginModalShow={props.setLoginModalShow} setPhonenum={setPhonenum} show={PhoneModalShow} onHide={() => setPhoneModalShow(false)} />
        </>
    );
}

export default SignInModal;
